import landingSimpleSetupLayerDev1 from "./images/landing-simple-setup-layer-dev-1.png";
import landingSimpleSetupPhone1 from "./images/landing-simple-setup-phone-1.png";
import landingSimpleSetupPhone2 from "./images/landing-simple-setup-phone-2.png";
import landingSimpleSetupPhone3 from "./images/landing-simple-setup-phone-3.png";
import landingSimpleSetupLayerDev2 from "./images/landing-simple-setup-layer-dev-2.png";
import landingSimpleSetupLayer1 from "./images/landing-simple-setup-layer-1.png";
import landingSimpleSetupLayer2 from "./images/landing-simple-setup-layer-2.png";
import landingSimpleSetupPipeSeq0 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010_.png";
import landingSimpleSetupPipeSeq1 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__0.png";
import landingSimpleSetupPipeSeq2 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__1.png";
import landingSimpleSetupPipeSeq3 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__2.png";
import landingSimpleSetupPipeSeq4 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__3.png";
import landingSimpleSetupPipeSeq5 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__4.png";
import landingSimpleSetupPipeSeq6 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__5.png";
import landingSimpleSetupPipeSeq7 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__6.png";
import landingSimpleSetupPipeSeq8 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__7.png";
import landingSimpleSetupPipeSeq9 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__8.png";
import landingSimpleSetupPipeSeq10 from "./images/landing-simple-setup-Pipes-Seq_2__00000-00010__9.png";

export default {
  v: "5.12.1",
  fr: 30,
  ip: 0,
  op: 180,
  w: 1460,
  h: 720,
  nm: "Brand-Slide-2-seq2-full-size",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 1406,
      h: 1440,
      u: "",
      p: landingSimpleSetupLayerDev1,
      e: 0,
    },
    {
      id: "image_1",
      w: 766,
      h: 1114,
      u: "",
      p: landingSimpleSetupPhone1,
      e: 0,
    },
    {
      id: "image_2",
      w: 766,
      h: 1120,
      u: "",
      p: landingSimpleSetupPhone2,
      e: 0,
    },
    {
      id: "image_3",
      w: 766,
      h: 1120,
      u: "",
      p: landingSimpleSetupPhone3,
      e: 0,
    },
    {
      id: "image_4",
      w: 1440,
      h: 1382,
      u: "",
      p: landingSimpleSetupLayerDev2,
      e: 0,
    },
    {
      id: "image_5",
      w: 446,
      h: 262,
      u: "",
      p: landingSimpleSetupLayer1,
      e: 0,
    },
    {
      id: "image_6",
      w: 504,
      h: 205,
      u: "",
      p: landingSimpleSetupLayer2,
      e: 0,
    },
    {
      id: "imgSeq_0",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq0,
      e: 0,
    },
    {
      id: "imgSeq_1",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq1,
      e: 0,
    },
    {
      id: "imgSeq_2",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq2,
      e: 0,
    },
    {
      id: "imgSeq_3",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq3,
      e: 0,
    },
    {
      id: "imgSeq_4",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq4,
      e: 0,
    },
    {
      id: "imgSeq_5",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq5,
      e: 0,
    },
    {
      id: "imgSeq_6",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq6,
      e: 0,
    },
    {
      id: "imgSeq_7",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq7,
      e: 0,
    },
    {
      id: "imgSeq_8",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq8,
      e: 0,
    },
    {
      id: "imgSeq_9",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq9,
      e: 0,
    },
    {
      id: "imgSeq_10",
      w: 1084,
      h: 1004,
      t: "seq",
      u: "",
      p: landingSimpleSetupPipeSeq10,
      e: 0,
    },
    {
      id: "sequence_0",
      layers: [
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_0",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 0,
          st: 0,
          op: 1,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_1",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 1,
          st: 1,
          op: 2,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_2",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 2,
          st: 2,
          op: 3,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_3",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 3,
          st: 3,
          op: 4,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_4",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 4,
          st: 4,
          op: 5,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_5",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 5,
          st: 5,
          op: 6,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_6",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 6,
          st: 6,
          op: 7,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_7",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 7,
          st: 7,
          op: 8,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_8",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 8,
          st: 8,
          op: 9,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_9",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 9,
          st: 9,
          op: 10,
          sr: 1,
          bm: 0,
        },
        {
          ty: 2,
          sc: "#00ffff",
          refId: "imgSeq_10",
          ks: {
            p: { a: 0, k: [0, 0] },
            a: { a: 0, k: [0, 0] },
            s: { a: 0, k: [100, 100] },
            r: { a: 0, k: [0] },
            o: { a: 0, k: [100] },
          },
          ip: 10,
          st: 10,
          op: 12,
          sr: 1,
          bm: 0,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: "pos-2",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 40,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 110,
              s: [730, 366, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 180, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 3,
      nm: "pos-1",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 40,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 110,
              s: [730, 354, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 180, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: "layer-dev-1.png",
      cl: "png",
      parent: 2,
      refId: "image_0",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 20,
              s: [0],
            },
            { t: 35, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [181, -1, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 40, s: [201, -1, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [703, 720, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 20,
              s: [39, 39, 100],
            },
            { t: 40, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: "phone-1.png",
      cl: "png",
      refId: "image_1",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [20],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 20,
              s: [100],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 45,
              s: [100],
            },
            { t: 57, s: [0] },
          ],
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 0,
              s: [10],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 20,
              s: [0],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 45,
              s: [0],
            },
            { t: 57, s: [-15] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [1350, 471, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.333, y: 0.333 },
              t: 20,
              s: [1280, 441, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 45,
              s: [1280, 441, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 57, s: [1220, 501, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [383, 557, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [36, 36, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 20,
              s: [50, 50, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 45,
              s: [50, 50, 100],
            },
            { t: 57, s: [40, 40, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: "phone-2.png",
      cl: "png",
      refId: "image_2",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 45,
              s: [0],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 60,
              s: [100],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 95,
              s: [100],
            },
            { t: 107, s: [0] },
          ],
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 45,
              s: [10],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 60,
              s: [0],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 95,
              s: [0],
            },
            { t: 107, s: [-15] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 45,
              s: [1350, 471, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.167, y: 0.167 },
              t: 60,
              s: [1280, 441, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 95,
              s: [1280, 441, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 107, s: [1220, 501, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [383, 560, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 45,
              s: [36, 36, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 60,
              s: [50, 50, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 95,
              s: [50, 50, 100],
            },
            { t: 107, s: [40, 40, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 182,
      st: 45,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: "phone-3.png",
      cl: "png",
      refId: "image_3",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 95,
              s: [0],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 110,
              s: [100],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 144,
              s: [100],
            },
            { t: 156, s: [0] },
          ],
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 95,
              s: [10],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 110,
              s: [0],
            },
            {
              i: { x: [0.833], y: [1] },
              o: { x: [0.167], y: [0] },
              t: 144,
              s: [0],
            },
            { t: 156, s: [-15] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 95,
              s: [1350, 471, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 0.667 },
              o: { x: 0.167, y: 0.167 },
              t: 110,
              s: [1280, 441, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 144,
              s: [1280, 441, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 156, s: [1220, 501, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [383, 560, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 95,
              s: [36, 36, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 110,
              s: [50, 50, 100],
            },
            {
              i: { x: [0.833, 0.833, 0.833], y: [1, 1, 1] },
              o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] },
              t: 144,
              s: [50, 50, 100],
            },
            { t: 156, s: [40, 40, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 182,
      st: 95,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: "phone-1.png",
      cl: "png",
      refId: "image_1",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 144,
              s: [0],
            },
            { t: 159, s: [100] },
          ],
          ix: 11,
        },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 144,
              s: [10],
            },
            { t: 159, s: [0] },
          ],
          ix: 10,
        },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 144,
              s: [1350, 471, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 159, s: [1280, 441, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [383, 557, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 144,
              s: [36, 36, 100],
            },
            { t: 159, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 182,
      st: 144,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: "layer-dev-2.png",
      cl: "png",
      parent: 1,
      refId: "image_4",
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              t: 20,
              s: [0],
            },
            { t: 32, s: [100] },
          ],
          ix: 11,
        },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [212, -7, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 37, s: [192, -7, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [720, 691, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 20,
              s: [45, 45, 100],
            },
            { t: 37, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 2,
      nm: "layer-1.png",
      cl: "png",
      parent: 2,
      refId: "image_5",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [181, -49, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 20,
              s: [181, -20, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 40, s: [181, -19, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [223, 131, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [90, 90, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 2,
      nm: "layer-2.png",
      cl: "png",
      parent: 1,
      refId: "image_6",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [169, 65, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.167, y: 0 },
              t: 20,
              s: [169, 44, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 40, s: [169, 43, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [252, 102.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [80, 80, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 11,
      ty: 4,
      nm: "mask-pipes",
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [775.506, 361.363, 0], ix: 2, l: 2 },
        a: { a: 0, k: [45.506, 14.363, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ef: [
        {
          ty: 29,
          nm: "Gaussian Blur",
          np: 5,
          mn: "ADBE Gaussian Blur 2",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 0,
              nm: "Blurriness",
              mn: "ADBE Gaussian Blur 2-0001",
              ix: 1,
              v: { a: 0, k: 30, ix: 1 },
            },
            {
              ty: 7,
              nm: "Blur Dimensions",
              mn: "ADBE Gaussian Blur 2-0002",
              ix: 2,
              v: { a: 0, k: 1, ix: 2 },
            },
            {
              ty: 7,
              nm: "Repeat Edge Pixels",
              mn: "ADBE Gaussian Blur 2-0003",
              ix: 3,
              v: { a: 0, k: 0, ix: 3 },
            },
          ],
        },
      ],
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: {
                a: 1,
                k: [
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 13,
                    s: [0, 84.7],
                  },
                  {
                    i: { x: [0.833, 0.833], y: [0.833, 0.833] },
                    o: { x: [0.167, 0.167], y: [0.167, 0.167] },
                    t: 25,
                    s: [560, 146.7],
                  },
                  { t: 36, s: [559, 514] },
                ],
                ix: 2,
              },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [175.506, 14.363], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Rectangle 1",
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 181,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 12,
      ty: 0,
      nm: "Pipes-Seq 2_[00000-00010].png",
      cl: "png",
      tt: 1,
      tp: 11,
      refId: "sequence_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [903, 362, 0], ix: 2, l: 2 },
        a: { a: 0, k: [542, 502, 0], ix: 1, l: 2 },
        s: { a: 0, k: [50, 50, 100], ix: 6, l: 2 },
      },
      ao: 0,
      tm: {
        a: 1,
        k: [
          {
            i: { x: [0.833], y: [0.833] },
            o: { x: [0.167], y: [0.167] },
            t: 0,
            s: [0],
          },
          { t: 11, s: [0.367] },
        ],
        ix: 2,
        x: "var $bm_rt;\n$bm_rt = loopOut();",
      },
      w: 1084,
      h: 1004,
      ip: 0,
      op: 181,
      st: 0,
      bm: 0,
    },
  ],
  markers: [
    { tm: 40, cm: "1", dr: 0 },
    { tm: 180, cm: "2", dr: 0 },
  ],
  props: {},
};
